<template>
    <div>
        <page-header :heading="pageHeader.title"
                     :buttons="pageHeader.buttons" />

        <search-form key="claimsSearch1"
                     :inputs="searchInputs"
                     class="mb-5"
                     @clear="handleClearClick"
                     @search="handleSearchClick"
                     v-model="searchFormValue" />
        <hr />
        <!--<div>
        <b-dropdown size="lg" id="claimActions" text="Actions" class="m-md-2">
            <b-dropdown-item @click="handleExportClick">
                Export
            </b-dropdown-item>
            <b-dropdown-item :disabled="!(selectedItems && selectedItems.length > 0)"
                             @click="handleStatusClick">
                Change status
            </b-dropdown-item>
            <b-dropdown-item :disabled="!(selectedItems && selectedItems.length > 0)"
                             @click="handleTaskClick">
                Mark As
            </b-dropdown-item>
        </b-dropdown>
    </div>

    <hr />
    <transition name="fade">
        <select-status v-if="showStatus && (selectedItems && selectedItems.length > 0)"
                       :statuses="manualStatuses"
                       :reasons="declinationReasons"
                       :button_text="`Set Status (${selectedItems.length} records)`"
                       class="mb-2 border-bottom"
                       @button-click="handleUpdateSelectedClick" />
    </transition>

    <transition name="fade">
        <select-task v-if="showFlag && (selectedItems && selectedItems.length > 0)"
                     :tasks="options"
                     :button_text="`Set Task (${selectedItems.length} records)`"
                     class="mb-2 border-bottom"
                     @button-click="handleUpdateFlagsClick" />
    </transition>

    <transition name="fade">
        <data-list-csv v-if="showExport"
                       class="mb-2 border-bottom"
                       :dataCols="claimsCols"
                       :dataListItems="claimsList"
                       :selectedItems="selectedItems">
        </data-list-csv>

    </transition>-->

        <div>
            <b-dropdown size="lg" id="claimActions" text="Actions" class="m-md-2">
                <b-dropdown-item @click="handleExportClick">
                    Export
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <hr />
        <data-list-csv v-if="showExport"
                       class="mb-2 border-bottom"
                       :dataCols="claimsListCols"
                       :dataListItems="claimsList"
                       :selectedItems="selectedItems">
        </data-list-csv>
        <div class="row">
            <div class="col">
                <page-size v-model="pageSize"
                           @input="reloadMessages()" />
            </div>
            <div class="col">
                <button type="button" class="btn btn-secondary btn-sm float-right ml-2 mb-2" v-on:click="handleRefreshClick"><i class="fas fa-sync-alt"></i> Refresh</button>
            </div>
        </div>
        <data-list :dataCols="claimsListCols"
                   :dataListItems="claimsList"
                   :tableClass="'table table-striped table-sm'"
                   @column-click="handleSortClick"
                   :showCheckbox="true"
                   @change="handleSelectedItemsChange"
                   @dbl-click="handleItemDblClick" />

        <b-pagination align="center"
                      size="md"
                      :total-rows="totalRecords"
                      v-model="pageNumber"
                      :per-page="pageSize"
                      @input="reloadMessages" />

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true"></loading>
    </div>
</template>

<script>

import { mapActions, mapGetters } from "vuex";

//import claimsSearch from '@/mixins/claimsSearch.js'
//import OrderBy from '@/components/OrderBy.vue'
import PageHeader from '@/components/PageHeader.vue'
import DataList from '@/components/DataList.vue'
//import DataListCSV from '@/components/DataListCSV.vue'
//import SelectStatus from '@/components/SelectStatus.vue'
//import SelectTask from '@/components/SelectTask.vue'
import PageSize from '@/components/PageSize.vue'
import SearchForm from '@/components/SearchForm.V2.vue'
//import { searchInputs, searchInputs2, searchInputs3 } from '@/ui.config/inputs/claimsBucket1SearchInputs'
//import { claimsCols } from '@/ui.config/cols/claimsBucket1ClaimsCols'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'ClaimsBucketUnreadMsg',
    mixins: [
        //claimsSearch,
    ],
    components: {
        PageHeader,
        DataList,
        //'data-list-csv': DataListCSV,
        //'select-status': SelectStatus,
        //'select-task': SelectTask,
        PageSize,
        SearchForm,
        Loading,
        //OrderBy
    },
    data: () => {
        return {
            pageHeader: {
                title: 'Claims with unread messages',
            },

            isLoading: false,

            //claimsCols: claimsCols,
            claimsListCols: [
                {
                    key: 'messageDate',
                    display: 'Message Date',
                    showSort: true
                },
                {
                    key: 'insuranceLineName',
                    display: 'Insurance Line'
                },
                {
                    key: 'resellerName',
                    display: 'Reseller'
                },
                {
                    key: 'claimReference',
                    display: 'Claim Reference'
                },
                {
                    key: 'relatedReference',
                    display: 'Related Reference'
                },
                {
                    key: 'productName',
                    display: 'Product'
                },
                {
                    key: 'claimType',
                    display: 'Claim Type'
                },
                {
                    key: 'dateCreated',
                    display: 'Claim Submitted Date',
                    showSort: true
                },
                {
                    key: 'incidentDate',
                    display: 'Incident Date',
                    showSort: true
                },
                {
                    key: 'number',
                    display: 'Policy Number'
                },
                {
                    key: 'email',
                    display: 'Claimant'
                },
                {
                    key: 'claimStatus',
                    display: 'Claim Status'
                },
                {
                    key: 'claimDecision',
                    display: 'Claim Decision'
                },
                {
                    key: 'imeiNos',
                    display: 'IMEIs'
                },
                {
                    key: 'serailNos',
                    display: 'Serials'
                }
            ],

            selected: [], // Must be an array reference!

            //pageSize: 10,
            //pageNumber: 1,
            //totalRecords: 5,

            orderBy: 'EarliestDocumentDateCreatedUTC',
            sortDirection: 'DESC',

            // Override mixin
            orderByOptions: [],

            insuranceLineTypes: [
                {
                    id: 1,
                    label: 'GADGET'
                },
                {
                    id: 2,
                    label: 'TIGA'
                }
            ],
            claimStatuses: [],

            searchFormValue: null,

            showExport: false,
            selectedItems: null
        }
    },
    beforeMount() {
        //this.loadMessages(this.buildPayload())
        this.clearClaimsList()
        this.fetchResellers()
        this.fetchIncidentTypes()

        this.fetchStatuses()
            .then(
                response => {
                    this.claimStatuses = response.data
                },
                error => console.log(error)
            )
            .catch(error => console.log(error));
    },
    mounted() {
        
    },
    computed: {
        ...mapGetters({
            claimsList: "messageStore/claimsMessagesTaskUncompleted",
            //claimsListCols: "messageStore/claimsListCols"
        }),
        resellers() {
            return this.$store.getters.resellers
        },
        incidentTypes() {
            return this.$store.getters.incidentTypesDisplayLabel1
        },
        searchInputs() {

            let { resellers, incidentTypes, insuranceLineTypes, claimStatuses } = this

            return [
                {
                    id: 'insuranceLine',
                    label: 'Insurance Line',
                    type: 'select',
                    options: insuranceLineTypes
                },
                {
                    id: 'reseller',
                    label: 'Reseller',
                    type: 'select',
                    options: resellers
                },
                {
                    id: 'claimReference',
                    label: 'Claim Reference',
                    type: 'text',
                    placeholder: 'Claim Reference'
                },
                {
                    id: 'relatedReference',
                    label: 'Related Reference',
                    type: 'text',
                    placeholder: 'Related Reference'
                },
                {
                    id: 'policyNumber',
                    label: 'Policy Number',
                    type: 'text',
                    placeholder: 'Policy Number'
                },
                {
                    id: 'claimantEmail',
                    label: 'Claimant Email',
                    type: 'text',
                    placeholder: 'Claimant Email'
                },
                {
                    id: 'incidentDate',
                    label: 'Incident Date',
                    type: 'text',
                    placeholder: 'YYYY/MM/DD'
                },
                {
                    id: 'incidentType',
                    label: 'Incident Type',
                    type: 'select',
                    options: incidentTypes
                },
                {
                    id: 'claimStatus',
                    label: 'Claim Status',
                    type: 'select',
                    options: claimStatuses
                }
            ]
        },
        approveRoute() {
            return '/buckets/claimunreadmessages/approve'
        },
        pageNumber: {
            get() {
                return this.$store.getters.pageNumber
            },
            set(value) {
                this.$store.commit('setPageNumber', value)
            }
        },
        totalRecords() {
            return this.$store.getters.totalRecords
        },
        pageSize: {
            get() {
                return this.$store.getters.pageSize
            },
            set(value) {
                this.$store.commit('setPageSize', value)
            }
        }
    },
    methods: {
        ...mapActions({
            //loadMessages: "messageStore/fetchClaimsWithMessagesUnread",
            loadMessages: 'messageStore/fetchClaimsWithMessagesUncompleted',
            fetchSelectedClaim: 'fetchSelectedClaimEx',
            clearSelectedClaim: 'clearSelectedClaim',
            setSelectedClaimIndex: 'setSelectedClaimIndex',
            clearClaimsList: 'clearClaimsList',
            fetchStatuses: 'fetchStatuses',
            fetchResellers: 'fetchResellers',
            fetchIncidentTypes: 'fetchIncidentTypes'
        }),
        reloadMessages() {
            if (this.claimsList && this.claimsList.length > 0)
                this.loadMessages(this.buildPayload())
        },
        handleItemDblClick({ index, claimId }) {
            this.clearSelectedClaim()
            this.fetchSelectedClaim(claimId)
            this.setSelectedClaimIndex(index)
            this.$router.push(this.approveRoute)

        },
        handleSortClick(payload) {
            switch (payload.key) {
                case 'dateCreated':
                    this.orderBy = 'DateCreated'
                    break;
                case 'incidentDate':
                    this.orderBy = 'IncidentDate'
                    break;
                case 'messageDate':
                    this.orderBy = 'EarliestDocumentDateCreatedUTC'
                    break;
            }
            if (this.sortDirection == null || this.sortDirection == 'ASC') {
                this.sortDirection = 'DESC'
            } else {
                this.sortDirection = 'ASC'
            }

            this.loadMessages(this.buildPayload())
        },
        buildPayload(searchCriteria) {

            let criteria = {}

            if (searchCriteria != null) {
                let { reseller, claimReference, relatedReference, policyNumber, claimantEmail, incidentDate, incidentType, fastTrackFilter, insuranceLine, portalGroupId, claimStatus } = searchCriteria

                criteria = {
                    resellerId: reseller ? reseller.id : null,
                    claimReference,
                    relatedReference,
                    policyNumber,
                    claimantEmail,
                    incidentDate,
                    incidentTypeId: incidentType ? incidentType.id : null,
                    insuranceLineId: insuranceLine ? insuranceLine.id : null,
                    claimStatus: claimStatus ? claimStatus.id : null
                }
            }

            let {
                orderBy,
                sortDirection,
                pageSize,
                pageNumber
            } = this

            return {
                ...criteria,
                orderBy,
                sortDirection,
                pageSize,
                pageNumber
            }
        },
        handleClearClick() {
            this.handleSearchClick(null)
        },
        handleSearchClick(payload) {
            
            this.loadMessages(this.buildPayload(payload))
                .then(response => {
                    console.log('loadmessages - response: ', response)
                }, error => {
                    console.log('loadmessages - error: ', error)
                })
        },
        handleRefreshClick() {
            this.handleSearchClick(this.searchFormValue)
        },
        handleSelectedItemsChange(payload) {
            this.selectedItems = payload
        },
        handleExportClick() {
            this.showExport = true
        },
    }
}
</script>

<style>
</style>

